import React, {useRef, useState, useEffect} from 'react'
import './editProduct.css'
import NewProduct from './newProduct'
import { findAllByDisplayValue } from '@testing-library/react'

function EditProduct(props) {
    const productName = useRef()
    const [searches, setSearches] = useState([]) // Used to store all the matching products object according to the search
    const chosenProduct = useRef()
    const [editProduct, setEditProduct] = useState(false) // while false, so searching for an item, while true = an item was found.
    const chosenIndex = useRef()

    let ExecuteSearch = (e, name) => {
        e.preventDefault();
        if (name.length < 3) {
            if (window.location.href.includes('/en')) { 
                alert("You must enter at least 3 characters to search.");
            } else {
                alert("עליך להקליד לפחות 3 תווים כדי לבצע חיפוש.");
            }   
            return;
        }

        let newArr = []; 
        // Searching the items according to the search
        props.menu.map((value, categoryIndex) => {
            value.products.map((product, productIndex) => {
                // Using indexOf and not includes because Includes isn't supposed in internet explorer :@
                if (product.productName.toLowerCase().indexOf(name.toLowerCase()) !== -1) {
                    product.categoryName = value.title;
                    product.categoryIndex = categoryIndex; // Storing their relative index in menu to for editing them specifically in NewProduct component
                    product.productIndex = productIndex;  //    ^
                    newArr.push(product);
                }
            })
        })
        setSearches(newArr);
        if (newArr.length===0) {
            document.getElementById('editProduct').reset();
        }
    }
    let sendSpecificProduct = (product, index) => {
        chosenProduct.current = product;
        chosenIndex.current = index;
        setEditProduct(true); // An item was found
    }
    let sendCopy = (product) => {
        props.maxpicks.value = product.maxpicks;
        props.setArrOptions(product.options);
        props.setArrExtras(product.extras);
        document.getElementById('editProductWrapper').style.display = 'none';
    }

if (window.location.href.includes('/en')) { 
    return (
        <div>
        {editProduct==false ?
            <React.Fragment>
                <form id="editProduct">
                    <div className="middleWrapper">
                        <label>Enter Item's name<span></span> </label>
                        <input type="text" ref={productName}/>
                        <button id="mainButton" onClick={(e) => ExecuteSearch(window.event, productName.current.value)}>SEARCH</button>
                    </div>
                </form>

                <div id="searchesProducts">
                    {searches.length===0  ? <div style={{paddingTop: '20px'}}> No results found </div>
                    :
                    <ol>
                        {props.fromCopy ? 
                        <React.Fragment>
                            {searches.map((value, index) => 
                                <li key={index} onClick={() => sendCopy(value)}>{value.productName} €{value.price} ({value.categoryName}) </li>
                            )}
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {searches.map((value, index) => 
                                <li key={index} onClick={() => sendSpecificProduct(value, index)}>{value.productName} €{value.price} ({value.categoryName}) </li>
                            )}
                        </React.Fragment>
                        } 
                    </ol>
                    }
                </div>
            </React.Fragment>
        :
        <NewProduct menu={props.menu} chosenLang={props.chosenLang} editedProduct={chosenProduct.current} setEditProduct={setEditProduct} searches={searches} setSearches={setSearches} chosenIndex={chosenIndex.current}/> }
            
        </div>    
    )
}

    return (
        <div>
            {editProduct==false ?
                <React.Fragment>
                    <form id="editProduct">
                        <div className="middleWrapper">
                            <label>שם המוצר<span></span> </label>
                            <input type="text" ref={productName}/>
                            <button id="mainButton" onClick={(e) => ExecuteSearch(window.event, productName.current.value)}>חיפוש</button>
                        </div>
                    </form>

                    <div id="searchesProducts">
                        {searches.length===0  ? <div style={{paddingTop: '20px'}}> לא נמצאו תוצאות </div>
                        :
                        <ol>
                            {props.fromCopy ? 
                            <React.Fragment>
                                {searches.map((value, index) => 
                                    <li key={index} onClick={() => sendCopy(value)}>{value.productName} €{value.price} ({value.categoryName}) </li>
                                )}
                            </React.Fragment>
                            :
                            <React.Fragment>
                                {searches.map((value, index) => 
                                    <li key={index} onClick={() => sendSpecificProduct(value, index)}>{value.productName} €{value.price} ({value.categoryName}) </li>
                                )}
                            </React.Fragment>
                            }   

                        </ol>
                        }
                    </div>
                </React.Fragment>
            :
            <NewProduct menu={props.menu} chosenLang={props.chosenLang} editedProduct={chosenProduct.current} setEditProduct={setEditProduct} searches={searches} setSearches={setSearches} chosenIndex={chosenIndex.current}/> }
            
        </div>
    )
}

export default EditProduct
